import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { AiOutlineFilePdf } from 'react-icons/ai'

const Resume = () => {
    return (
        <Fade direction="up" triggerOnce={true} fraction={0.6}>
            <button className="resume-download flex w-fit mt-[5rem] lg:mt-[7rem] transition hover:translate-x-3 hover:scale-110 hover:border-2 hover:border-[rgba(77,234,167,0.9)] hover:bg-[rgba(77,234,167,0.9)] hover:text-gray-700 duration-300 border rounded-[0.2rem] p-1 group">
                <a
                    href="https://drive.google.com/file/d/1Difl8pTleHXmeFNW-xXURzgS50EglTUc/view?usp=sharing"
                    target="_blank" rel="noopener noreferrer"
                >
                    <div className="resume-view inline-flex items-center gap-2">
                        <p className='text-[1.5rem] md:text-[2rem] lg:text-[2.5rem] lg:leading-[3.25rem]'>View Resume</p>
                        <AiOutlineFilePdf
                            size="2rem"
                            className="resume-icon border hover:border-gray-700 rounded-[100%] p-[5px] group-hover:border-gray-700"
                        />
                    </div>
                </a>
            </button>
        </Fade>
    )
}

export default Resume